// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsDP56agSLNWyoiD7-_SyHLcQ1PqsgooM",
  authDomain: "vasavi-fbdf5.firebaseapp.com",
  databaseURL: "https://vasavi-fbdf5-default-rtdb.firebaseio.com",
  projectId: "vasavi-fbdf5",
  storageBucket: "vasavi-fbdf5.firebasestorage.app",
  messagingSenderId: "729105129140",
  appId: "1:729105129140:web:7f4345a51c57884883c1e1",
  measurementId: "G-9RZ51EX0D6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);